import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
} from 'rxjs/operators';
import {
  LOCAL_CHANNEL_FIND,
  LOCAL_CHANNEL_FIND_SUCCESS,
  LOCAL_CHANNEL_FAILED,
  LOCAL_CHANNEL_UPDATE_ID,
  TIP_FIND,
  LOCAL_CHANNEL_FIND_SESION,
  LOCAL_CHANNEL_FIND_SESION_SUCCESS,
  DELIVERY_ZONE_FIND_ALL,
  CHECK_BUSINESS_DAY,
  CHANNEL_SETTING_FIND_ALL,
  AVAILABILITY_FIND_ALL,
 } from '../actions'
import { LocalChannelService } from '@core/services';
import {
  getJuvoTrackSessionChannels,
  requireLocalChannelByCode,
} from '@core/domain/local-channel';
import { Platform } from '@core/enums';

@Injectable()
export class LocalChannelEffects {
  constructor(
    private actions$: Actions,
    private localChannelService: LocalChannelService,
  ) {}

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOCAL_CHANNEL_FIND),
      mergeMap(() =>
        this.localChannelService.getAllLocalCanalByTiendaID().pipe(
          mergeMap(({ data }) => {
            const channelOlo = requireLocalChannelByCode(data, Platform.JuvOnline);
            return [
              LOCAL_CHANNEL_UPDATE_ID({ localChannelId: channelOlo.idLocalCanal }),
              LOCAL_CHANNEL_FIND_SUCCESS({localChannel: data}),
              AVAILABILITY_FIND_ALL(),
              DELIVERY_ZONE_FIND_ALL(),
              CHECK_BUSINESS_DAY(),
              CHANNEL_SETTING_FIND_ALL(),
              TIP_FIND(),
            ];
          }),
          catchError((error) =>
            of(
              LOCAL_CHANNEL_FAILED({
                error: error.error?.message || 'Error loading local canals',
              })
            )
          )
        )
      )
    )
  );

  findSesion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOCAL_CHANNEL_FIND_SESION),
      mergeMap(({sesion}) =>
        this.localChannelService.getAllLocalCanalByTiendaID(sesion).pipe(
          mergeMap(({ data }) => {
            const juvoTrack = getJuvoTrackSessionChannels(data);
            return [
              LOCAL_CHANNEL_FIND_SESION_SUCCESS({sesion: juvoTrack}),
            ];
          }),
          catchError((error) =>
            of(
              LOCAL_CHANNEL_FAILED({
                error: error.error?.message || 'Error loading local canals',
              })
            )
          )
        )
      )
    )
  );
}